import React, { useState } from 'react';
import { useLocation } from 'react-router';

import { Link } from 'react-router-dom';
import PanelBoxLayout from 'components/layout/panelBox';
import NotificationCreateSendToAllForm from './lib/sendToAllForm';

import * as S from './styles';
import DepartmentAndFloorForm from './lib/departmentFloorForm';
import NotificationCreateSendToUserForm from './lib/sendToUserForm';

interface IProps {
  departments: string[];
  floors: { list: any[] };
  userList: {
    list: [];
    totalPages: null;
  };
}

/*
 * The design's tabbed form: the tabs are the top edge of the card, and the
 * panel is its body. They used to be three loose links above the card with a
 * `<Gap>` either side, so the choice of audience read as page navigation
 * rather than as part of the form it changes.
 *
 * The labels say who receives it — "Everyone" rather than "Send to all" —
 * because the verb is already on the button at the foot.
 */
const TABS = [
  { hash: '#sendToAll', label: 'Everyone' },
  { hash: '#departmentAndFloor', label: 'Department and floor' },
  { hash: '#sendToUsers', label: 'Specific people' }
];

const NotificationCreateTabs: React.FC<IProps> = ({ departments, floors, userList }) => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<string | undefined>(location?.hash || '#sendToAll');

  const handleChangeTab = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <S.Container>
      <PanelBoxLayout className="flush" contentStyle={{ padding: 0 }}>
        <S.Tabs role="tablist">
          {TABS.map((tab) => (
            <Link key={tab.hash} to={tab.hash} tabIndex={-1}>
              <S.Tab
                role="tab"
                aria-selected={activeTab === tab.hash}
                onClick={() => handleChangeTab(tab.hash)}
                className={activeTab === tab.hash ? 'active' : ''}
              >
                {tab.label}
              </S.Tab>
            </Link>
          ))}
        </S.Tabs>
        <S.TabPanel>
          {activeTab === '#sendToAll' ? (
            <NotificationCreateSendToAllForm data={{}} />
          ) : activeTab === '#departmentAndFloor' ? (
            <DepartmentAndFloorForm departments={departments} floors={floors} />
          ) : activeTab === '#sendToUsers' ? (
            <NotificationCreateSendToUserForm userList={userList.list} />
          ) : (
            <></>
          )}
        </S.TabPanel>
      </PanelBoxLayout>
    </S.Container>
  );
};

export default NotificationCreateTabs;
